import { useShouldShowIAFeature } from 'hooks/IAFeaturesHook';
export const useShouldShowAutoRating = () => useShouldShowIAFeature('ai_auto_rating');
export const useShouldShowAIProspectSection = () => useShouldShowIAFeature('ai_customroleplays');
